<div #header class="infoScreenHeader bg-primary p-3 text-white">
  <div class="row">

    <div class="col h3">
      <img src="{{assetPath}}icons/applogo.png" alt="logo"> {{'ROOM_OCCUPANCY'|translate}}
    </div>

    <div class="col text-center h3">
      {{description}}
    </div>

    <div class="col text-right h3">
      {{watch}} {{'OCLOCK'|translate}}
    </div>

  </div>
</div>

<table class="table table-striped time-grid">
  <thead>
    <tr>
      <th scope="col">{{'ROOM'|translate}}</th>
      <th class="border-left" scope="col" *ngFor="let i of hours" colspan="12">{{i}}:00
        <div *ngIf="isCurrentHour(i)" class="time-line" [style.left]="timelineLeft" [style.height]="timelineHeight">
        </div>
      </th>
    </tr>

  </thead>
  <tbody>
    <tr *ngFor="let room of displayRooms">
      <th scope="row">{{room.Ressource}}</th>
      <td scope="col" *ngFor="let i of slices" [class.border-left]="isFullHour(i)">
        <div class="time-slice" [class.bg-primary]="room.isInUse(i)">&nbsp;</div>
      </td>
    </tr>
  </tbody>
</table>

<div #footer class="fixed-bottom bg-primary text-right p-3">
  <app-qr-code *ngIf="displayQrCode" [url]="qrCodeUrl"></app-qr-code>
</div>